<template>
    <div>
        <div class="container">
            <div class="row">
                <!-- <title-area :title="this.$t('sistemi_prokurorial.page.disciplining.title')"/> -->
                <title-area v-if="headerTitle" :title="headerTitle" />
                <p>
                    {{ this.$t('sistemi_prokurorial.page.disciplining.description') }}
                </p>
                <h3 class="text-decoration-underline">
                    {{ this.$t('sistemi_prokurorial.page.disciplining.secondTitle') }}
                </h3>
            </div>
        </div>
    </div>
</template>
<script>
import TitleArea from '../share/TitleArea.vue'
import { useRoute } from 'vue-router';

export default {
  components: { TitleArea },
  data(){
    return{
        aaa:"Vleresimi i performances",
        headerTitle:"",
        route: useRoute(),
    }
  },
   
    compoennts:{
        TitleArea
    },
    mounted(){
        this.headerTitle = this.$route.query.title;
    },
    watch: {
        'route.query.title'(newVal) {
        this.headerTitle = newVal;
        }
    },
}
</script>
<style scoped>
    p{
        color:#101826;
        font-size:16px;
    }

    h3{
        color:#101826;
    }
</style>